/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Vue from "vue";

const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;

export default [{
  url: "/dashboard-consultant",
  name: "Dashboard",
  slug: "dashboard-consultant",
  icon: "PieChartIcon",
},
{
  url: '/patient-journey',
  name: "Jornada do paciente",
  slug: "patient-journey",
  icon: "GitCommitIcon",
  i18n: "patient-journey",
  submenu: [{
    url: "/general-requests",
    name: "Solicitações",
    slug: "general-requests",
    i18n: "general-requests"
  },
  {
    url: "/general-appointments",
    name: "Consultas",
    slug: "general-appointments",
    i18n: "general-appointments"
  },
  {
    url: "/general-returns",
    name: "Retorno",
    slug: "general-returns",
    i18n: "general-returns"
  },
  ],

},
{
  url: "/customers",
  name: "Clientes",
  slug: "customers",
  icon: "UsersIcon",
},
{
  url: '/medicine',
  name: "Medicamentos",
  slug: "medicine",
  icon: "BookOpenIcon",
  i18n: "medicine",
  submenu: [
    {
      url: "/divers",
      name: "Diversos",
      slug: "divers",
      i18n: "financial-statement-filoo"
    },
    {
      url: "/pharmacy",
      name: "Farmácias",
      slug: "pharmacy",
      i18n: "pharmacy"
    },
  ],

},
{
  url: '/reports-consultant',
  name: "Relatórios",
  slug: "reports-consultante",
  icon: "FileTextIcon",
  i18n: "reports-consultant",
  submenu: [
    {
      url: "/analytical-consultation-of-schedules",
      name: "Consulta Analítica de Agendamentos",
      slug: "/analytical-consultation-of-schedules",
      i18n: "analytical-consultation-of-schedules"
    },
    {
      url: "/quicksight-attendance-dashboard",
      name: "Painéis BI",
      slug: "quicksight-attendance-dashboard",
      i18n: "quicksight-attendance-dashboard",
    },
    {
      url: "/customer-report-attendance",
      name: "Relatório de Clientes",
      slug: "customer-report-attendance",
      i18n: "customer-report-attendance"
    },
  ],

},
{
  url: "/laboratory-exams",
  name: "Exames",
  slug: "laboratory-exams",
  icon: "DropletIcon",
},
{
  url: "/laboratory-search",
  name: "Laboratórios",
  slug: "laboratory-search",
  icon: "HomeIcon",
},
{
  url: "/managed-match",
  name: "Match Administrado",
  slug: "managed-match",
  icon: "CheckCircleIcon",
},
{
  url: '/ainda-nao-tem',
  name: "Cadastros",
  slug: "reports-consultante",
  icon: "ArchiveIcon",
  i18n: "reports-consultant",
  isPresented: isProjectPlan,
  submenu: [
    {
      url: "/associate-lab-exam",
      name: "Associação de laboratórios e exames",
      slug: "associate-lab-exam",
      i18n: "associate-lab-exam"
    },
    {
      url: "/register-marketplace-categoria",
      name: "Cadastro de categorias do marketplace",
      slug: "register-marketplace-categoria",
      i18n: "register-marketplace-categoria"
    },
    {
      url: "/register-specialty",
      name: "Cadastro de especialidade",
      slug: "specialty-register",
      i18n: "specialty-register"
    },
    {
      url: "/register-exames",
      name: "Cadastro de exames",
      slug: "exames-register",
      i18n: "exames-register"
    },
    {
      url: "/register-laboratory",
      name: "Cadastro de laboratórios",
      slug: "register-laboratory",
      i18n: "register-laboratory"
    },
    {
      url: "/register-medicine",
      name: "Cadastro de medicamentos",
      slug: "register-medicamento",
      i18n: "register-medicamento"
    },
    {
      url: "/register-parceiros",
      name: "Cadastro de parceiros",
      slug: "register-parceiros",
      i18n: "register-parceiros"
    },
    {
      url: "/register-marketplace-produto",
      name: "Cadastro de produtos do marketplace",
      slug: "register-marketplace-produto",
      i18n: "register-marketplace-produto"
    },
  ]

}
]
